import request from '@/utils/request'

/**
 * 用户注册
 * @param {Object} data 注册数据
 * @returns {Promise} Promise对象
 */
export function registerUser(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/register.pcUserRegister',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 发送短信验证码
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function sendMessageCode(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/register.messageCode',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}